export default {
    None: 0,
    Like: 1,
    HaventDecided: 2,
    DisLike: 3
}